import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, CardBody, CardHeader, Col, Modal, Button, ModalHeader, Row, ModalFooter, ModalBody, CardFooter } from "reactstrap";
import Swal from "sweetalert2";
import { configuration } from "../appConfig";
// import CustomerInfoTable_newswiss from "./common/CustomerInfoTable_newswiss";
import NewSwissPriceTable from "./common/NewSwissPriceTable";
import ReactToPrint from "react-to-print";
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import connectDATSWISS from "./DAT/importDatSWISS";
import Axios from "axios";
import { calculatePrice } from "../pricing/calculatePrice";
import CarSvgSwiss from "../carbodyparts/CarSvgSwiss";
import ScrollToTop from "./common/ScrollToTop";
import "./newstyle.css";
import "./common/print.css";
import NewSwissPriceTable_zh from "./common/NewSwissPriceTable_zh";
import Newswiss_CustomerInfoTable from "./common/newswiss_CustomerInfoTable";
import AllReportScanImages from "./common/AllReportScanImages";
import Spinner from "../../src/spinner/index";
import { token } from "../appTokenConfig";
import SwissDATReportAuthorization from "./common/SwissDATReportAuthorization";

let zurichArr = ['zürich', 'zurich', 'zurigo', 'zurich', "z%c3%bcrich+versicherung"];


function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export class SwissDATReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: "",
      order: {
        vinNumber: "",
        orderNumber: Math.round(Math.random() * 100000000),
        issuedOn: new Date(),
      },
      lang: "",
      words: {},
      authLoading: false,
      data: {},
      DATReportAuthorized: false,
      isDATReportAuthorizedKeyExists: false,
      modal: false,
      name: "",
      error: [],
      id: "",
      partDetails: null,
      twoDView: true,
      vinNumber: null,
      vinfolderList: [],
      showTwoDView: true,
      selectedPartInfo: [],
      scanresult: [],
      imgTypeReport: true,
      jsonData: {},
      downloadingZipfile: false,
      downloadProgress: 0,
      modal_dents: false,
      TotalDentCount: "",
      modal_Auth: false,
      ReportGenerated: false,
      isJSONLoading: false,
      PreDamage: "",
      imageLoading: true,
      PDFPrintShow: false,
      PDFPrintHide: true
    };
    this.setImageLoading = this.setImageLoading.bind(this);
  }
  count = [];

  async componentDidMount() {
    this.vinFolderList();
    this.getLang();
    this.getData();
  }
  pageLanguage = {
    ch: "Seite",
    fr: "Page",
    en: "Page",
    us: "Page",
  };
  pageOfLanguage = {
    ch: "von",
    fr: "de",
    en: "of",
    us: "of",
  };
  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  setShowPDFPrint = () => {
    this.setState({ PDFPrintShow: true });
  }

  setHidePDFPrint = () => {
    this.setState({ PDFPrintHide: false });
  }

  setImageLoading(loading) {
    this.setState({ imageLoading: loading });
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.fullData) {
      this.setState({
        Authorized: nextProps.fullData.Authorized,
        fullData: nextProps.fullData
      })
    }
    if (nextProps.lang !== prevState.lang) {
      this.setState({ lang: nextProps.lang })
    } else { return }
  }

  getData = () => {
    this.setState({
      isJSONLoading: true
    })
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    axios.get(`${configuration.getData}?vin=${selectedFile}&partnerId=${partnerId}`)
      .then((r) => {
        if (r.data) {
          this.setState({
            data: r.data,
            DATReportAuthorized:
              r.data && r.data.DATReportAuthorized
                ? r.data.DATReportAuthorized
                : false,
            isDATReportAuthorizedKeyExists: r.data.hasOwnProperty("DATReportAuthorized"),
            Authorized: r.data.Authorized,
            id: r.data.Authorized ? r.data.DriveThrough == "1" ? "drive_in" : "drive_through" : "",
            TotalDentCount: r.data.TotalDentCount ? r.data.TotalDentCount : "0",
            ReportGenerated: r.data.ReportGenerated,
            name: r.data.AuthorizedName,
            customerCompany: r.data.CustomerCompany ? r.data.CustomerCompany : '',
            isJSONLoading: false,
            PreDamage: r.data.PreDamage,
            ReportGeneratedStatus: r.data.hasOwnProperty('ReportGeneratedStatus') ? r.data.ReportGeneratedStatus : 'FAIL',
            jsonData: r.data
          });
        }
      })
      .catch((err) => {
        alert(err);
        this.setState({
          isJSONLoading: false
        })
      });
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
        "?vin=" +
        selectedFile +
        "&partnerId=" +
        partnerId
      );

      // isScanListRecord START
      if (response.data[0]) {
        this.setState({
          isScanListRecord: response.data[0].isScanListRecord,
        });
      }
      // isScanListRecord END

      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
        response.data[0].resultTXT.scanresult && this.countDetails(response.data[0].resultTXT.scanresult);
      }
    } else {
      this.props.history.push("/login");
    }
  };
  countDetails = async (rowArray) => {
    let promises = [];
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    for (let i = 0; i < rowArray.length; i++) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        vin +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i].part;
      promises.push(Axios.get(url));
    }
    const arrRes = await Axios.all(promises);
    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");
      val.map((r) => {
        let val2 = r.split(" ")[3];
        if (val2 && parseInt(val2) > 25) {
          gtcount = gtcount + 1;
        }
        if (val2 && parseInt(val2) < 26) {
          ltcount = ltcount + 1;
        }
        return val2;
      });
      return {
        part: result.data.part,
        count: val.length - 1,
        lt25: ltcount,
        gt25: gtcount,
        ltunit: calculatePrice(24, ltcount),
        gtunit: calculatePrice(26, gtcount),
      };
    });
    this.setState({ swissTable: ltgtdata });
  };

  updateJSON = (authorized) => {
    const { id } = this.state;
    var driveinid = id == "drive_in" ? "1" : "0"
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    let msg = authorized
      ? driveinid == "0" ? this.lang("All reports are being generated. Please check All Scan Records page after sometime.") : "DAT Report Created Sucessfully"
      : "De-Authorize PDF successfully!";
    const url = configuration.PostEditorChanges + `?partnerId=${partnerId}&vin=${selectedFile}`;
    let payload = {
      ...this.state.fullData,
      // DATReportAuthorized: true,
      DATReportAuthorized: authorized,
      Authorized: authorized,
      AuthorizedName: this.state.name,
      DriveThrough: driveinid,
      ReportGenerated: authorized,
      ReportGeneratedStatus: 'PENDING'
    };
    if (!authorized) {
      axios.post(url, payload)
        .then((res) => {
          if (res.data.status === 200) {
            this.setState({
              DATReportAuthorized: authorized,
              authLoading: false,
              deAuthLoading: false,
              data: payload,
              isDATReportAuthorizedKeyExists: true,
              Authorized: authorized,
              AuthorizedName: authorized == true ? this.state.name : "",
              modal_Auth: false,
              ReportGeneratedStatus: 'PENDING'
            });
            Toast.fire({
              type: "success",
              title: msg,
            });
          }
        })
        .catch((err) => {
          Toast.fire({
            type: "error",
            title: 'Something went wrong!',
          });
        });
    } else {
      this.setState({
        DATReportAuthorized: authorized,
        authLoading: false,
        deAuthLoading: false,
        data: payload,
        isDATReportAuthorizedKeyExists: true,
        Authorized: authorized,
        AuthorizedName: authorized == true ? this.state.name : "",
        modal_Auth: false
      });
      Toast.fire({
        type: "success",
        title: msg,
      });
    }
  };
  updateJSON_th = (authorized) => {
    const { id } = this.state;
    var driveinid = id == "drive_in" ? "1" : "0"
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    let msg = authorized
      ? driveinid == "0" ? this.lang("All reports are being generated. Please check All Scan Records page after sometime.") : "DAT Report Created Sucessfully"
      : "De-Authorize PDF successfully!";
    const url = configuration.PostEditorChanges + `?partnerId=${partnerId}&vin=${selectedFile}`;
    let payload = {
      ...this.state.fullData,
      // DATReportAuthorized: true,
      DATReportAuthorized: authorized,
      Authorized: authorized,
      AuthorizedName: this.state.name,
      DriveThrough: driveinid,
      // ReportGenerated : authorized
    };
    this.setState({
      DATReportAuthorized: authorized,
      authLoading: false,
      deAuthLoading: false,
      data: payload,
      isDATReportAuthorizedKeyExists: true,
      Authorized: authorized,
      AuthorizedName: authorized == true ? this.state.name : "",
      modal_Auth: false
    });
    Toast.fire({
      type: "success",
      title: msg,
    });
  };

  DATReportAuthorized = () => {
    // const {isDATReportAuthorizedKeyExists} = this.state;
    // this.setState({
    //   authLoading: true,
    // });
    // !isDATReportAuthorizedKeyExists ? 
    //   this.generateSwissDATReport()
    // :
    //   Swal.fire({
    //     title: `<p className="swal-custome-text">${this.lang("authorizedPdfFMsg")}</p>`,
    //     showCancelButton: true,
    //     confirmButtonText: this.lang("Yes"),
    //     cancelButtonText: this.lang("No"),
    //     confirmButtonColor: "#d80707",
    //   }).then((result) => {
    //     /* Read more about isConfirmed, isDenied below */
    //     if (result.value) {
    //       this.generateSwissDATReport();
    //     } else {
    //       this.setState({
    //         authLoading: false,
    //       });
    //     }
    //   });
  };

  internalStatus = async (vin) => {
    const url = configuration.internalStatus;
   let payload = {
    vin: vin,
    status: 3,
   }
   const headers = {
    Authorization: `Bearer ${token}`,
   };
    await Axios.post(url, payload, { headers })
  }

  generateSwissDATReport = () => {
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    this.setState({
      authLoading: true,
      modal_Auth: true
    });
    let url = configuration.generateSwissDATReport;
    const url1 = configuration.PostEditorChanges + `?partnerId=${partnerId}&vin=${selectedFile}`;
    let payload = {
      partnerId: partnerId,
      vin: selectedFile,
    };
    axios.post(url1, { ...this.state.fullData, DriveThrough: "1", ReportGenerated: false, AuthorizedName: this.state.name, ReportGeneratedStatus: 'PENDING' })
      .then((res) => {
        if (res.data.status === 200) {
          axios.post(url, payload)
            .then((res) => {
              this.internalStatus(selectedFile);
              if (res.data.status === 200) {
                this.updateJSON(true);
              }
            })
            .catch((err) => {
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
              this.setState({
                authLoading: false,
                modal_Auth: false
              });
            });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: 'Something went wrong!',
        });
      });
  }

  generateSwissDATReportdrivethrough = async () => {
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    this.setState({
      authLoading: true,
      modal_Auth: true
    });
    const url = configuration.automated_scripts_PDFDAT;
    let payload1 = {
      partnerId,
      vin,
      authorizer_name: this.state.name
    }
    const url1 = configuration.PostEditorChanges + `?partnerId=${partnerId}&vin=${selectedFile}`;
    let payload = {
      partnerId: partnerId,
      vin: selectedFile,
    };
    await Axios.post(url1, { ...this.state.fullData, DriveThrough: "0", ReportGenerated: false, AuthorizedName: this.state.name, ReportGeneratedStatus: 'PENDING' })
      .then(async (res) => {
        await Axios.post(url, payload1)
          .then(async (res) => {
            // this.state.fullData.Authorized = true
            if (res.status === 200) {
              // this.updateJSON(true);
              this.internalStatus(selectedFile);
              this.updateJSON_th(true);
            } else if (res.data.status === 500) {
              this.setState({
                authLoading: false,
                modal_Auth: false
              })
              // vin or partner Id missing
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
            } else {
              this.setState({
                authLoading: false,
                modal_Auth: false
              })
              Toast.fire({
                type: "error",
                title: "pdf generate failed",
              });
            }
          }).catch(err => {
          })
      }).catch(err => {
      })

  }

  DATReportDeAuthorized = () => {
    this.setState({
      deAuthLoading: true,
    });
    Swal.fire({
      title: `<p className="swal-custome-text">${this.lang("deAuthorizedPdfMsg")}</p>`,
      showCancelButton: true,
      confirmButtonText: this.lang("Yes"),
      cancelButtonText: this.lang("No"),
      confirmButtonColor: "#d80707",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.value) {
        this.updateJSON(false);
      } else {
        this.setState({
          deAuthLoading: false,
          Authorized: true
        });
      }
    });
  };
    handleChange = (e) => {
    // this.setState({
    //   [ e.target.name] : e.target.value
    //   })
    const inputValue = e.target.value;
    const cleanedInput = inputValue.trimStart();
    // const cleanedInput = inputValue.replace(/[^a-z\s]/gi, '');
    this.setState({
      name: cleanedInput
    })
  }

  handleSave = () => {
    const { name, id } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    let error = [];
    if (name.trim() == "") {
      error.push("Please enter your name")
    }
    if (error.length) {
      this.setState({
        error: error,
        modal: true
      })
    } else {
      this.setState({
        error: [],
      })
    }
    if (id == "drive_in") {
      const url = configuration.authorizernamestore + `?partnerId=${partnerId}&vin=${vin}&name=${name}&drive_type=${"drive_in"}`;
      axios.post(url).then((res) => {
        if (res.data.status === 200) {
          if (!error.length) {
            window.history.pushState(null, "", window.location.href);
            window.onpopstate = function () {
              window.history.pushState(null, "", window.location.href);
            };
            this.generateSwissDATReport();
            this.setState({ modal: false, })
          }
        }
      })
    } else {
      if (!error.length) {
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = function () {
          window.history.pushState(null, "", window.location.href);
        };
        this.generateSwissDATReportdrivethrough();
        this.setState({ modal: false })
      }
    }
  }
  downloadDAT = async () => {
    let vin = localStorage.getItem('selectedFile');
    let row = { vin: vin }
    this.setState({
      datLoading: true
    })
    let loader = await connectDATSWISS(row);
    this.setState({
      datLoading: loader,
    })
  }
ReportDownload = async () => {
    const vin = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    const lang = localStorage.getItem("lang");
    this.setState({
      downloadingZipfile: true
    })

    const url = configuration.downloadReports + `?partnerId=${partnerId}&vin=${vin}&lang=${lang}`;
    await Axios.get(url)
      .then(async (res) => {
        this.setState({
          downloadingZipfile: false
        })
      }).catch(err => {
      })

  }
  downloadReportZip = () => {
    this.setState({
      downloadingZipfile: true
    })
    let [partnerId, vin] = [localStorage.getItem('partnerId'), localStorage.getItem('selectedFile')]
    const { lang } = this.state
    let url = `${configuration.downloadReports}?partnerId=${partnerId}&vin=${vin}&lang=${lang}`
    axios.get(url)
      .then((res) => {
        if (res.data.status === 200) {
          this.downloadFile(res.data.data, `${vin}.zip`)
            .then(() => {
              this.setState({
                downloadingZipfile: false,
                downloadProgress: 0
              })
              Toast.fire({
                type: "success",
                title: "Zip download successfully!",
              });
            }).catch((err) => {
              this.setState({
                downloading: false,
                downloadProgress: 0
              })
              Toast.fire({
                type: "error",
                title: "Something want wrong!",
              });
            })
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something want wrong!",
        });
      })
  }
  downloadFile = async (file, fileName) => {
    return new Promise((resolve, reject) => {
      if (file) {
        const options = {
          onDownloadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            this.setState({
              downloadProgress: Math.floor((loaded * 100) / total),
            });
          },
        };

        axios.get(file, {
          responseType: "blob",
          ...options,
        }).then(function (response) {

          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          })
      } else {
        reject();
      }
    })
  }

  changeAuthorizeFlag = (authorize, driveType) => {
    this.setState({
      jsonData: {
        ...this.state.jsonData,
        Authorized: authorize,
        DriveThrough:
          driveType === "drive_through"
            ? "0"
            : driveType === "drive_in"
              ? "1"
              : "",
      },
    });
  };

  render() {
    const { authLoading, deAuthLoading, DATReportAuthorized, isDATReportAuthorizedKeyExists, PDFPrintHide, Authorized, PDFPrintShow, customerCompany, isJSONLoading } = this.state;
    const selectedFile = localStorage.getItem("selectedFile");
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client")
    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT && scanResult.resultTXT.scanresult &&
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });
    const userSession = localStorage.getItem("userSession");
    const data = userSession ? JSON.parse(userSession) : {};
    const vin = localStorage.getItem("selectedFile");
    const { datLoading, ReportGeneratedStatus, imageLoading, } = this.state;
    const isZurichClient = customerCompany ? zurichArr.includes(customerCompany.split(' ')[0].toLowerCase()) : false;

    return (
      <div className="animated fadeIn">
        <div xs="12" sm="12" className="p-2">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-12 col-sm-12 col-12 mt-sm-10">
                    <small>
                      {" "}
                      {client === "SWISS" || client === "POLAND" ? <span>{this.lang("DashboardVIN")} : </span> :
                        <span>{this.lang("VIN Number")} : </span>} {selectedFile}
                    </small>
                  </div>
                  <div className="col-lg-9 col-md-12 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      <button className="btn-lg dat_download_button_vertical" onClick={() => this.downloadDAT()}>
                        {datLoading ?
                          <div className="spinner-border mr-1" role="status" style={{ width: "1.2rem", height: "1.2rem" }}>
                            <span className="sr-only">Loading...</span>
                          </div>
                          :
                          <></>
                        }
                        <img
                          className="datbutton_download"
                          src="../assets/images/dat-logo-vertical.png"
                          alt="DAT"
                        /> {" "}
                      </button>
                      {/* authorized DAT button */}
                      {/* <button
                        id="drive_in"
                        className={`glass btn btn-lg ${Authorized && this.state.id == "drive_in" ? "btn-success" : "btn-danger"
                          } mr-1`}
                        // onClick={() => this.generateSwissDATReport()}
                        onClick={() => this.state.TotalDentCount == 0 ? this.setState({ modal_dents: true, id: "drive_in" }) : this.setState({ modal: true, id: "drive_in" })}
                        disabled={authLoading || Authorized || (this.state.id == "drive_through" && Authorized)}
                      >
                        {authLoading && this.state.id == "drive_in" ? (
                          <div
                            className="spinner-border"
                            role="status"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <i className="fa fa-print" />
                        )}
                        &nbsp; {this.lang("pdfAuthorizeForsilverDATDrive-In")}
                      </button>
                      <button
                        id="drive_through"
                        className={`glass btn btn-lg ${Authorized && this.state.id == "drive_through" ? "btn-success" : "btn-danger"
                          }  mr-1`}
                        // className="glass btn btn-lg btn-danger mr-1"
                        disabled={authLoading || Authorized || (this.state.id == "drive_in" && Authorized)}
                        onClick={() => this.state.TotalDentCount == 0 ? this.setState({ modal_dents: true, id: "drive_through" }) : this.setState({ modal: true, id: "drive_through" })}
                      >
                        {authLoading && this.state.id == "drive_through" ? (
                          <div
                            className="spinner-border"
                            role="status"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <i className="fa fa-print" />
                        )}
                        &nbsp; {this.lang("pdfAuthorizeForsilverDATDrive-Through")}
                      </button> */}
                      {/* De-authorized DAT button */}
                      {/* {isDATReportAuthorizedKeyExists && Authorized && ReportGeneratedStatus !== 'PENDING' && (
                        <button
                          className={`glass btn btn-lg  mr-1 btn-danger`}
                          onClick={() => this.DATReportDeAuthorized()}
                          disabled={!Authorized || Authorized && !DATReportAuthorized}
                        >
                          {deAuthLoading ? (
                            <div
                              className="spinner-border"
                              role="status"
                              style={{ width: "1.5rem", height: "1.5rem" }}
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <i className="fa fa-print" />
                          )}
                          &nbsp; {this.lang("pdfDeAuthorizeForsilverDAT")}
                        </button>
                      )} */}

                      {/* Download Backend PDF report*/}
                      {/* {this.state.Authorized && (this.state.ReportGenerated == true) &&
                        <button
                          className={`btn btn-lg  mr-1 btn-danger`}
                          onClick={() => this.downloadReportZip()}
                          // disabled={!Authorized}
                          disabled={!Authorized && (this.state.ReportGenerated === undefined) || Authorized && !DATReportAuthorized }
                        >
                          {this.state.downloadingZipfile ? (
                            <div
                              className="spinner-border"
                              role="status"
                              style={{ width: "1.5rem", height: "1.5rem" }}
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <i className="fa fa-download" />
                          )}
                          &nbsp; {this.lang("Download report")}
                        </button>
                      } */}
                      {/* Print PDF */}
                      <SwissDATReportAuthorization setShowPDFPrint={this.setShowPDFPrint} setHidePDFPrint={this.setHidePDFPrint}/>
                      {
                      client == "SWISS" && PDFPrintShow ?
                      <ReactToPrint
                        trigger={() => {
                          document.title = localStorage.getItem("selectedFile");
                          return (
                            <button className="btn btn-danger btn-lg" disabled={!Authorized && (this.state.ReportGenerated === undefined) || Authorized && !DATReportAuthorized }>
                              <i className="fa fa-print" /> {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                      : 
                      <>
                      {
                        client == "SWISS" && PDFPrintHide && Authorized && (this.state.ReportGenerated === true) && ReportGeneratedStatus !== 'PENDING' && 
                          <ReactToPrint
                            trigger={() => {
                              document.title = localStorage.getItem("selectedFile");
                              return (
                                <button className="btn btn-danger btn-lg" disabled={!Authorized && (this.state.ReportGenerated === undefined) || Authorized && !DATReportAuthorized }>
                                  <i className="fa fa-print" /> {this.lang("Print PDF")}
                                </button>
                              );
                            }}
                            content={() => this.componentRef}
                          />
                      }
                      </>
                      }

                      {client !== "SWISS" &&
                      <ReactToPrint
                        trigger={() => {
                          document.title = localStorage.getItem("selectedFile");
                          return (
                            <button className="btn btn-danger btn-lg">
                              <i className="fa fa-print" /> {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      /> }

                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <CardBody style={{ padding: 0 }}>
            <div
              className="container all-reports-top-wrapper swiss-report-wrapper"
              ref={(el) => (this.componentRef = el)}
              style={{ padding: 0 }}
              data-content-name={this.pageOfLanguage[this.state.lang]}
            >
              {!imageLoading ? (
                <>
                  <div id="front-page-card" className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                    <div className="col-sm-12 full-height-col col-zero">
                      <Card className="show-footer">
                        <CardBody className="col-zero">
                          <div className="newFormatReport_wrapper headerRow">
                            <ReportHeader_Swiss />
                            {/* <CustomerInfoTable_newswiss /> */}
                            <Newswiss_CustomerInfoTable />
                            {isJSONLoading ?
                              <div className="container mt-50 damage-summary-section p-0">
                                <div className="row p-0">
                                  <div className="col-12 text-center">
                                    <h4 className="text-center">Loading...</h4>
                                  </div>
                                </div>
                              </div>
                              :
                              (isZurichClient ?
                                <div className="dat-price-table-wrapper">
                                  <NewSwissPriceTable_zh viewType='DAT' />
                                </div>
                                :
                                <div className="dat-price-table-wrapper">
                                  <NewSwissPriceTable className="dat"
                                    viewType="DAT"
                                  />
                                </div>
                              )
                            }
                          </div>

                        </CardBody>
                        <div id="report_page_one">
                          <ReportFooter_Swiss pageNo={1} reportType='newReportFull' />
                        </div>
                        {/* <CardFooter className="card-footer-bg">
                      </CardFooter> */}
                      </Card>
                    </div>
                  </div>


                  {/* CarSVG */}
                  {this.state.isScanListRecord == '0' &&
                    (

                      <div id="front-page-card-two" className="row row-zero page-break-row report-full-wrapper second-svg-section" data-content-name={this.lang("Page")}>
                        <div className="col-sm-12 full-height-col col-zero">
                          <Card className="show-footer">
                            <CardBody className="col-zero">
                              <div className="newFormatReport_wrapper">
                                <ReportHeader_Swiss />
                                <div className="container car-svg-main">
                                  <div className="row title-row-main">
                                    <div className="col-sm-12 col-zero">
                                      <h3 className="report-title">
                                        {this.lang("2D")}<span> {this.lang("View")}</span>{" "}
                                      </h3>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-sm-12 text-center">
                                      <CarSvgSwiss {...this.props} reportType='newReportFull' />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </CardBody>
                            <div id="report_page_two">
                              <ReportFooter_Swiss pageNo={2} reportType='newReportFull' />
                            </div>
                            {/* <CardFooter className="card-footer-bg">
                        </CardFooter> */}
                          </Card>
                        </div>
                      </div>

                    )
                  }
                </>
              ) : (
                <>
                  <Spinner />
                </>
              )}
              <AllReportScanImages imageLoading={this.state.imageLoading} setImageLoading={this.setImageLoading} />

            </div>
          </CardBody>
          <div>
            <ScrollToTop />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    fullData: props.jsonData
  };
};
export default connect(mapStateToProps)(SwissDATReport);
